module.exports = __webpack_public_path__ + "img/MatPL-2.0d21e293.png";